var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-111{fill:#fff;}.cls-222{fill:red;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menu_dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M92.9,64.3a.76.76,0,0,1-.06-.16c-.06-.18-.11-.37-.17-.56L92.52,63l.18.66C92.76,63.87,92.83,64.09,92.9,64.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M93,64.57s0,0,0,0a1.41,1.41,0,0,1-.06-.22C92.93,64.4,93,64.48,93,64.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M104,75.86h0S104,75.85,104,75.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M116.3,41.32a16.66,16.66,0,0,0-2.2-.61A14.58,14.58,0,0,1,116.3,41.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M116,76.08l-.14,0h0l-.56.17c-.19.06-.39.11-.58.15l.65-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M126.9,66.49c-.16.35-.34.7-.53,1C126.56,67.19,126.73,66.84,126.9,66.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M127.76,64.3c-.06.19-.12.37-.19.56,0,0,0,0,0,0l0,.15c-.07.17-.13.34-.21.51.08-.2.17-.41.24-.62S127.69,64.52,127.76,64.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M139.83,21.37H10.17A9.17,9.17,0,0,0,1,30.53v88.94a9.17,9.17,0,0,0,9.17,9.16H139.83a9.17,9.17,0,0,0,9.17-9.16V30.53A9.17,9.17,0,0,0,139.83,21.37Zm4.42,98.1a4.42,4.42,0,0,1-4.42,4.41H10.17a4.42,4.42,0,0,1-4.42-4.41V30.53a4.42,4.42,0,0,1,4.42-4.41H139.83a4.42,4.42,0,0,1,4.42,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M93.57,64.3a.75.75,0,0,1,0-.16c-.06-.18-.12-.37-.17-.56l0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M104.75,75.87h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M117,41.32a16.66,16.66,0,0,0-2.2-.61A14.58,14.58,0,0,1,117,41.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M127.57,66.49a11.31,11.31,0,0,1-.53,1C127.23,67.19,127.41,66.84,127.57,66.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M128.44,64.3c-.06.19-.12.37-.19.56,0,0,0,0,0,0a0,0,0,0,0,0,0,.69.69,0,0,1,0,.13,3.66,3.66,0,0,1-.21.51c.09-.2.17-.41.25-.62S128.37,64.52,128.44,64.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M93.38,63.66l0-.08c.05.19.11.38.17.56Zm21.4-22.95a16.66,16.66,0,0,1,2.2.61A14.58,14.58,0,0,0,114.78,40.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M131.57,56.27A20.75,20.75,0,0,0,120,40c-.59-.29-1.19-.54-1.8-.77l-.4-.14-.12,0-.7-.22a22.1,22.1,0,0,0-2.5-.59h0l-.79-.11h-.06l-.85-.09-.86,0-.86,0a20.71,20.71,0,1,0,0,41.41,21.07,21.07,0,0,0,4.66-.53,20.78,20.78,0,0,0,16-20.17A18.66,18.66,0,0,0,131.57,56.27ZM117,41.32a16.66,16.66,0,0,0-2.2-.61A14.58,14.58,0,0,1,117,41.32ZM93.52,64.14c-.06-.18-.12-.37-.17-.56l0,.08.19.64A.75.75,0,0,1,93.52,64.14Zm33.23-2.93c0,.22-.07.44-.11.65l-.15.66c0,.19-.1.39-.17.58,0,0,0,0,0,0a3.38,3.38,0,0,1-.13.42c0,.14-.09.29-.14.43s-.12.32-.18.47v0c-.09.21-.17.42-.27.63l0,0a5.2,5.2,0,0,1-.26.53,1.21,1.21,0,0,1-.09.2,4.67,4.67,0,0,1-.27.49c-.11.2-.22.41-.35.6a16,16,0,0,1-1.21,1.71l-.33.4c-.2.23-.41.47-.63.68a5.09,5.09,0,0,1-.41.4.23.23,0,0,1-.09.08,5.62,5.62,0,0,1-.44.41l-.07.06a4.42,4.42,0,0,1-.47.39l-.08.07-.51.38a5.72,5.72,0,0,1-.57.39c-.38.26-.78.5-1.18.72a13.75,13.75,0,0,1-1.28.62l-.37.16-.47.18-.67.23c-.17,0-.35.11-.53.15l-.49.13a2.88,2.88,0,0,1-.4.09,2.83,2.83,0,0,1-.4.08,4.5,4.5,0,0,1-.64.11,4.63,4.63,0,0,1-.52.07l-.56.06-.52,0-.75,0a16,16,0,1,1,0-31.91l.81,0,.65,0c.2,0,.4,0,.6.07l.17,0a4,4,0,0,1,.5.08l.16,0L107.67,61h19.12A1.29,1.29,0,0,1,126.75,61.21Zm-12.41-4.94,4.06-11.76a16,16,0,0,1,8.39,11.76ZM127,67.53c.19-.34.37-.69.53-1A11.31,11.31,0,0,1,127,67.53Zm1.21-2.67s0,0,0,0a0,0,0,0,0,0,0,.69.69,0,0,1,0,.13,3.66,3.66,0,0,1-.21.51c.09-.2.17-.41.25-.62s.15-.42.22-.64C128.38,64.49,128.32,64.67,128.25,64.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M93.38,63.66l0-.08c.05.19.11.38.17.56Zm21.4-22.95a16.66,16.66,0,0,1,2.2.61A14.58,14.58,0,0,0,114.78,40.71Zm3.38-1.5c.61.23,1.21.48,1.8.77l0-.13Zm13.41,17.06a18.66,18.66,0,0,1,.15,2.38V56.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M93.38,63.66l.14.48a.75.75,0,0,0,0,.16ZM127,67.53a11.31,11.31,0,0,0,.53-1C127.41,66.84,127.23,67.19,127,67.53Zm1.18-2.59c-.08.21-.16.42-.25.62a3.66,3.66,0,0,0,.21-.51.69.69,0,0,0,0-.13,0,0,0,0,1,0,0s0,0,0,0c.07-.19.13-.37.19-.56C128.37,64.52,128.29,64.73,128.22,64.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M128.22,64.94a.49.49,0,0,1,0,.11.69.69,0,0,0,0-.13S128.23,64.93,128.22,64.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M104.72,75.86Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 94.35,
    y1: 95.71,
    x2: 126.94,
    y2: 95.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M129.31,95.71a2.37,2.37,0,0,1-2.37,2.37H94.35a2.38,2.38,0,1,1,0-4.75h32.59A2.38,2.38,0,0,1,129.31,95.71Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 94.35,
    y1: 108.61,
    x2: 126.94,
    y2: 108.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M129.31,108.61a2.37,2.37,0,0,1-2.37,2.37H94.35a2.38,2.38,0,1,1,0-4.75h32.59A2.38,2.38,0,0,1,129.31,108.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M47.5,110.24a2.37,2.37,0,0,1-2.37-2.37V82.75a2.38,2.38,0,1,1,4.75,0v25.12A2.37,2.37,0,0,1,47.5,110.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M33.93,110.24a2.37,2.37,0,0,1-2.38-2.37V69.17a2.38,2.38,0,1,1,4.75,0v38.7A2.37,2.37,0,0,1,33.93,110.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M20.35,110.24A2.38,2.38,0,0,1,18,107.87V82.75a2.38,2.38,0,1,1,4.75,0v25.12A2.37,2.37,0,0,1,20.35,110.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M61.08,110.24a2.37,2.37,0,0,1-2.37-2.37V62.38a2.38,2.38,0,0,1,4.75,0v45.49A2.38,2.38,0,0,1,61.08,110.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M74.66,110.24a2.38,2.38,0,0,1-2.38-2.37V48.8a2.38,2.38,0,0,1,4.76,0v59.07A2.38,2.38,0,0,1,74.66,110.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M117,41.32a16.66,16.66,0,0,0-2.2-.61A14.58,14.58,0,0,1,117,41.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M93.57,64.3a.75.75,0,0,1,0-.16c-.06-.18-.12-.37-.17-.56l0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M104.75,75.87h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 150,
    height: 150
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboard);
export default __webpack_public_path__ + "static/media/menu_dashboard.5a9c898f.svg";
export { ForwardRef as ReactComponent };